export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["Loading"] = "TRANSLATIONS_LOADING";
    ActionTypes["Loaded"] = "TRANSLATION_LOADED";
    ActionTypes["Failed"] = "TRANSLATIONS_FAILED";
    ActionTypes["ChangeLanguage"] = "CHANGE_LANGUAGE";
})(ActionTypes || (ActionTypes = {}));
export var DEFAULT_LOCALE = 'en';
export var LOGGER_NAME = 'intl';
//# sourceMappingURL=constants.js.map